import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

interface IHandleGet {
  currentPage?: number;
  itensPerPage?: number;
  nameSearch?: string;

  codeOperadora?: string;
  produtorCode?: string;
  name?: string;
  isActive?: "TRUE" | "FALSE" | "ALL";

  funcao_produtor?: "ALL" | "CORRETOR" | "SUPERVISOR" | "GERENTE";

  tipo_produtor?:
  | "ALL"
  | "SALAO"
  | "REPASSE"
  | "FREE_LANCE"
  | "CONECTOR"
  | "ADMINISTRATIVO"
  | "INTERNO"
  | "HOME"
  | "START"
  | "MOVE"
  | "MASTER"
  | "SALAO_RUBY"
  | "SALAO_SAFIRA"
  | "SALAO_DIAMANTE"
  | "GRADE_DF"
  | "GRADE_GO"
  | "GRADE_MT"
  | "GRADE_SP"
  | "SALAO_MG"
  | "EXTERNO_MG"
  | "SALAO_FORTALEZA"
  | "EXTERNO_FORTALEZA"
  | "SALAO_BELEM"
  | "EXTERNO_BELEM"
  | "SALAO_RECIFE"
  | "EXTERNO_RECIFE"
  | "EXTERNO_ESPECIAL_RJ"
  | "EP_1"
  | "EP_2";
}

export const useHttpTableComissaoProdutor = () => {
  const { handleGetAlert } = useLayoutMainContext();
  const {
    setQtd_registros,
    setLoadingTable,
    itensPerPage,
    currentPage,
    nameSearch,
  } = useConfigPageContext();

  const { setListComissaoProdutor } = useContextComissoes();

  const handleGet = async (body: IHandleGet) => {
    setLoadingTable(true);

    api
      .post("/comissoes/GetProdutores", {
        ...body,
        page: currentPage,
        limit: itensPerPage,
        filter: body.name || nameSearch,
      })
      .then((res) => {
        setListComissaoProdutor(res.data.data);
        setQtd_registros(res.data.count);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet };
};
